






























































import { Component, Mixins } from "vue-property-decorator";
import { BrowserKinds, BrowserUtility } from "../../../utilities";

@Component
export default class BrowserInformationViewer extends Mixins() {
  results = {
    utility: {
      kind: BrowserUtility.getBrowserKind(),
      isMobile: BrowserUtility.isMobile(),
      isTouchSupported: BrowserUtility.isTouchSupported(),
      isChromiumBrowser: BrowserUtility.isChromiumBrowser(),
    },
    script: {
      navigator: {
        userAgent: navigator.userAgent,
        maxTouchPoints: navigator.maxTouchPoints,
      },
      window: {
        ontouchstart: "ontouchstart" in window,
        ontouchend: "ontouchend" in window,
        pointerCoarse: window.matchMedia("(pointer:coarse)").matches,
      },
      document: {
        ontouchstart: "ontouchstart" in document,
        ontouchend: "ontouchend" in document,
      },
    },
  };

  get kindAsString(): string {
    return this.kindsAsStrings[this.kindsAsStrings[this.results.utility.kind] ? this.results.utility.kind : BrowserKinds.Unknown];
  }

  get kindsAsStrings(): { [key: number]: string } {
    const results: { [key: number]: string } = [];
    results[BrowserKinds.Unknown] = "Unknown";
    results[BrowserKinds.InternetExplorer] = "InternetExplorer";
    results[BrowserKinds.MicrosoftEdge] = "MicrosoftEdge";
    results[BrowserKinds.GoogleChrome] = "GoogleChrome";
    results[BrowserKinds.Safari] = "Safari";
    results[BrowserKinds.MozillaFirefox] = "MozillaFirefox";
    results[BrowserKinds.Opera] = "Opera";
    results[BrowserKinds.ChromiumEdge] = "ChromiumEdge";
    return results;
  }
}
